// Imports Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContenedorComponent } from './components/contenedor/contenedor.component';

/** @namespace IngresoComponent */

/**
 * Routes associated to components
 * @constant
 * @type {Array<JSON>}
 */
const routes: Routes = [
    {   path: '', component: ContenedorComponent},
];

/** @module NgModule main app */
@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule],
    providers: []
})

/**
* Module main app routing
* @class
*/
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/app-routing.module.ts